import React, { useState } from 'react';
import './Login.css';
import { AlertCircle } from 'lucide-react';
import Logo from '../components/Logo';

interface Props {
  onLogin: (username: string, apiKey?: string) => void;
  onBack?: () => void;
}

const Login: React.FC<Props> = ({ onLogin, onBack }) => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim()) {
      setError('Identity required to hatch code.');
      return;
    }
    onLogin(username.trim());
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <Logo size={48} />
        </div>
        <h2>Codenest Access</h2>
        <p className="muted">Enter your handle to continue. Your workspace is stored locally.</p>

        <label>Handle</label>
        <input
          value={username}
          onChange={e => {
            setUsername(e.target.value);
            if (error) setError(null);
          }}
          placeholder="e.g. prompt_wizard"
        />

        {error && (
          <div className="error-banner">
            <AlertCircle size={14} />
            <span>{error}</span>
          </div>
        )}

        <div className="login-actions">
          <button type="submit" className="primary">Initialize Workspace</button>
          {onBack && <button type="button" className="link" onClick={onBack}>Return Home</button>}
        </div>
      </form>
    </div>
  );
};

export default Login;
